import React from "react";

const WevoLogo = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="40 1509 120 20.795"
            height="15px"
        >
            <g id="wevo_logo_w_icon" transform="translate(40 1509)">
                <path
                    id="Path_357"
                    data-name="Path 357"
                    fill="#66ba4d"
                    className="cls-1"
                    d="M34.319,25.615H26.831L19.2,10.4h7.488Z"
                    transform="translate(-10.043 -5.44)"
                />
                <path
                    id="Path_358"
                    data-name="Path 358"
                    fill="#66ba4d"
                    className="cls-1"
                    d="M35.1,20.175h7.488L52.7,0H45.211Z"
                    transform="translate(-18.359)"
                />
                <path
                    id="Path_359"
                    data-name="Path 359"
                    fill="#59c7fa"
                    className="cls-2"
                    d="M15.9,25.615h7.488L30.972,10.4H23.483Z"
                    transform="translate(-8.317 -5.44)"
                />
                <path
                    id="Path_360"
                    data-name="Path 360"
                    fill="#009994"
                    className="cls-3"
                    d="M29.268,23.9l3.72-7.488-3-6.01H28.5l-3,6.01Z"
                    transform="translate(-13.338 -5.44)"
                />
                <path
                    id="Path_361"
                    data-name="Path 361"
                    fill="#00a6e3"
                    className="cls-4"
                    d="M15.072,25.615H7.583L0,10.4H7.488Z"
                    transform="translate(0 -5.44)"
                />
                <path
                    id="Path_362"
                    data-name="Path 362"
                    fill="#fff"
                    className="cls-5"
                    d="M99.69,24.49,95.255,13v-.1h-2.1L88.72,24.49,84.142,12.9H81.9l5.866,14.261h1.908l4.483-11.685,4.579,11.685h1.908L106.415,12.9h-2.146Z"
                    transform="translate(-42.838 -6.747)"
                />
                <path
                    id="Path_363"
                    data-name="Path 363"
                    fill="#fff"
                    className="cls-5"
                    d="M179.608,24.728,173.885,13l-.048-.1H171.5l7.154,14.213.048.048h1.86l7.107-14.07.1-.191h-2.385Z"
                    transform="translate(-89.704 -6.747)"
                />
                <path
                    id="Path_364"
                    data-name="Path 364"
                    fill="#fff"
                    className="cls-5"
                    d="M221.848,19.582c0,3.482-2.623,5.723-6.677,5.723-3.959,0-6.534-2.242-6.534-5.676s2.575-5.771,6.439-5.866h.143a7.043,7.043,0,0,1,5.008,1.86,5.28,5.28,0,0,1,1.622,3.959M215.6,12a10.016,10.016,0,0,0-7.2,2.48,6.907,6.907,0,0,0-2.1,5.1,7.114,7.114,0,0,0,2.289,5.246,9.615,9.615,0,0,0,6.63,2.242c5.2,0,8.967-3.1,8.967-7.393-.048-3.768-2.671-7.583-8.585-7.679"
                    transform="translate(-107.906 -6.275)"
                />
                <path
                    id="Path_365"
                    data-name="Path 365"
                    fill="#fff"
                    className="cls-5"
                    d="M139.134,15.625a5.688,5.688,0,0,1,4.531-1.86,6.692,6.692,0,0,1,3.911,1.1,5.053,5.053,0,0,1,2.289,3.243H137.942a4.355,4.355,0,0,1,1.192-2.48Zm13.211,4.1a7.719,7.719,0,0,0-2.242-5.294,9.45,9.45,0,0,0-12.5-.143A6.963,6.963,0,0,0,135.7,19.2c0,4.388,3.768,7.774,8.537,7.774a9.474,9.474,0,0,0,4.913-1.335,10.046,10.046,0,0,0,2.862-2.909l.143-.191h-2.337l-.048.048a2.389,2.389,0,0,1-.334.382,6.616,6.616,0,0,1-3.673,2.051,5.445,5.445,0,0,1-1.288.1c-4.2,0-6.3-2.766-6.534-5.342h14.5Z"
                    transform="translate(-70.978 -6.277)"
                />
                <path
                    id="Path_366"
                    data-name="Path 366"
                    fill="#fff"
                    className="cls-5"
                    d="M247.729,41.108H247.4V39.582l-.1.334-.382,1.24h-.286l-.382-1.24-.1-.334v1.526h-.334v-1.86h.429l.477,1.479.477-1.479h.429v1.86Zm-2.576,0h-.334V39.486h-.62V39.2h1.526v.286h-.572Z"
                    transform="translate(-127.729 -20.504)"
                />
            </g>
        </svg>
    );
};

export default WevoLogo;



// WEBPACK FOOTER //
// ./src/components/WevoLogo.js